import i18n from 'theme/i18n';
import { useEventStore } from 'store/event/eventStore';
import { usePredictorStore } from 'store/predictor/predictorStore';
import './HeaderLogo.scss';

const getHeaderClassname = () => {
  const variantTwoLogos = ['sk', 'pt-BR', 'pt', 'pl', 'nb', 'es', 'es-LA', 'cz'];
  return variantTwoLogos.find((item) => i18n.language === item) === undefined ? 'default' : 'variant';
};

const HeaderLogo = () => {
  const activePredictor = usePredictorStore((s) => s.activePredictor);
  const inPlay = useEventStore((s) => s.inPlay);

  return (
    <div className={`logo-container--${getHeaderClassname()}`}>
      <img
        alt='Racing Game Logo'
        className={`logo logo--${i18n.language}${activePredictor && inPlay ? ' logo--in-play' : ''}`}
      />
    </div>
  );
};
export default HeaderLogo;
